import { render, staticRenderFns } from "./RelatorioLogFaq.vue?vue&type=template&id=63db1bba"
import script from "./RelatorioLogFaq.vue?vue&type=script&lang=js"
export * from "./RelatorioLogFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports